import React, { useCallback, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { Container, Row, Col } from 'react-bootstrap';

import PacienteCadastro, { ICartao } from '../../components/PacienteCadastro';
import PacientePagamento from '../../components/PacientePagamento';
import PacienteMenu from '../../components/PacienteMenu';
import Historico from '../../components/Historico';
import PacienteDocumento from '../../components/PacienteDocumento';
import PacienteAnexo from '../../components/PacienteAnexo';

interface IUrlParams {
  id: string;
}

interface IPacienteMenu {
  PacNome: string;
  PacNomeSocial: string;
  PacCodigo: number;
  avatar_url?: string;
  possuiCartao: boolean;
  cartao?: ICartao[];
}

const PacienteCadastroPagina: React.FC = () => {
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;
  const [pacCodigo, setPacCodigo] = useState<number | undefined>(
    id ? Number(id) : undefined,
  );
  const [path, setPath] = useState<string>('dados');

  const [dadosMenu, setDadosMenu] = useState<IPacienteMenu>({
    PacCodigo: 0,
    PacNome: 'Carregando...',
    PacNomeSocial: '',
    avatar_url: '',
    possuiCartao: false,
    cartao: undefined,
    // pathAtivo: 'dados',
  });

  const handleSetDadosMenu = useCallback((dados: IPacienteMenu) => {
    setDadosMenu(dados);
  }, []);

  const handleSetpath = useCallback((pathSelceionado: string) => {
    setPath(pathSelceionado);
  }, []);

  return (
    <Container fluid className="mt-2">
      <Row noGutters>
        {pacCodigo && pacCodigo > 0 ? (
          <Col md={2} className="pr-md-2">
            <PacienteMenu
              nome={dadosMenu.PacNome}
              nomeSocial={dadosMenu.PacNomeSocial}
              avatar_url={dadosMenu.avatar_url}
              codigo={dadosMenu.PacCodigo}
              cartao={
                dadosMenu.possuiCartao && dadosMenu.cartao
                  ? dadosMenu.cartao[0]
                  : undefined
              }
              pathAtivo={path}
              handleSelectPath={handleSetpath}
            />
          </Col>
        ) : (
          <></>
        )}
        <Col md={pacCodigo && pacCodigo > 0 ? 10 : 12}>
          {path === 'dados' && (
            <PacienteCadastro
              pacCodigo={pacCodigo}
              handleDadosMenu={handleSetDadosMenu}
            />
          )}
          {path === 'historico' && (
            <div className="bg-white rounded border">
              <Historico pacCodigo={dadosMenu.PacCodigo} />
            </div>
          )}
          {path === 'pagamentos' && (
            <div className="bg-white rounded border">
              <PacientePagamento pacCodigo={dadosMenu.PacCodigo} />
            </div>
          )}
          {path === 'documentos' && (
            <div className="bg-white rounded border">
              <PacienteDocumento pacCodigo={dadosMenu.PacCodigo} />
            </div>
          )}
          {path === 'anexos' && (
            <div className="bg-white rounded border">
              <PacienteAnexo pacCodigo={dadosMenu.PacCodigo} />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default PacienteCadastroPagina;
